import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function Seat(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M7.5 3.75a1.25 1.25 0 112.5 0 1.25 1.25 0 01-2.5 0zM8.75 1a2.75 2.75 0 100 5.5 2.75 2.75 0 000-5.5zm-.554 8.857a1.005 1.005 0 011.992-.26l.764 4.792a.75.75 0 00.741.632h3.843c.693 0 1.347.32 1.774.866l2.926 3.751a1.165 1.165 0 11-1.853 1.412l-2.181-2.931a2.75 2.75 0 00-2.207-1.109H10.96a2.25 2.25 0 01-2.238-2.02l-.526-5.133zm1-2.607a2.505 2.505 0 00-2.492 2.76l.526 5.132a3.75 3.75 0 003.73 3.368h3.035c.395 0 .767.187 1.003.504l2.181 2.931a2.665 2.665 0 104.24-3.23l-2.927-3.751a3.75 3.75 0 00-2.957-1.443h-3.202l-.663-4.16A2.505 2.505 0 009.196 7.25zM3.909 9.004a1 1 0 011.087.905l.752 8.272A1.999 1.999 0 007.738 20H13a1 1 0 110 2H7.739a3.999 3.999 0 01-3.983-3.638l-.752-8.271a1 1 0 01.905-1.087z",
    clipRule: "evenodd"
  }));
}

export default Seat;